import { call, fork, put, takeLatest } from 'redux-saga/effects';

import * as types from '../constants/actionTypes';
import actions from '../actions';
import api from '../lib/api';
import notify from '../lib/notify';

export function* fetchDriversSaga() {
  try {
    yield put(actions.driver.fetchDriversLoading());
    const data = yield call(api.driver.search, { status: 'approved' });
    yield put(actions.driver.fetchDriversSuccess(data));
  } catch (e) {
    yield put(actions.driver.fetchDriversError());
    yield call(notify, e);
  }
}

export function* watchDriversSaga() {
  yield takeLatest(types.FETCH_DRIVERS, fetchDriversSaga);
}

export default [
  fork(watchDriversSaga),
];
